class AvaliacaoOpcaoResposta {

    /**
     * Cria uma nova instância de uma opção de resposta para a avaliação
     * @param {Number} id Id da opção de esposta 
     * @param {String} descricao Descrição da opção
     * @param {String} imagem Imagem associada à opção
     * @param {Number} valor Valor da opção, quando a questão gerar um gráfico
     * @param {Number} ordem Ordem da opção na lista
     */
    constructor(id, descricao, imagem, valor, ordem) {
        /** @member {Number} id Id da opção de esposta  */
        this.id        = id        ?? null;
        /** @member {String} descricao Descrição da opção */
        this.descricao = descricao ?? null;
        /** @member {String} imagem Imagem associada à opção */
        this.imagem    = imagem    ?? null;
        /** @member {Number} valor Valor da opção, quando a questão gerar um gráfico */
        this.valor = valor ?? null;
        /** @member {Number} ordem Ordem da opção na lista */
        this.ordem     = ordem     ?? null;
    }

    /**
     * Cria uma cópia do objeto
     * @param {AvaliacaoOpcaoResposta} origem Objeto a ser copiado
     * @returns {AvaliacaoOpcaoResposta} Retorna um novo objeto com os mesmos dados do original
     */
    static clone(origem) {
        return new AvaliacaoOpcaoResposta(origem.id, origem.descricao, origem.imagem, origem.valor, origem.ordem);
    }

}

export default AvaliacaoOpcaoResposta;